import { createFileRoute } from "@tanstack/react-router";
import { useApp } from "@/context/AppContext";
import { ClientProjectDetail } from "@/pages/client/ClientProjectDetail";
import { ProjectDetail } from "@/pages/team/ProjectDetail";

/** Eine Adresse, zwei Sichten: das Team-Detail mit Aufgaben-Board, der Kunde seine Projektseite. */
export const Route = createFileRoute("/_angemeldet/projekte/$id")({
	component: ProjektDetailSeite,
});

function ProjektDetailSeite() {
	const { role } = useApp();
	const { id } = Route.useParams();
	return role !== "mitarbeiter" ? <ClientProjectDetail id={id} /> : <ProjectDetail id={id} />;
}
